import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";


import 'admin-lte/dist/css/adminlte.css'
import 'admin-lte/dist/js/adminlte'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.css'
import axios from "axios";



Vue.config.productionTip = false
const token = localStorage.getItem('users-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token;
}
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
